"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InvoiceItem;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = require("classnames");
const material_1 = require("@mui/material");
const react_1 = require("react");
const InfoOutlined_1 = require("@mui/icons-material/InfoOutlined");
const merge_1 = require("merge");
const HalfItemIcon_1 = require("../../assets/icons/HalfItemIcon");
const InvoiceItemTypes_1 = require("../../types/InvoiceItemTypes");
const Format_1 = require("../Format");
const icons_1 = require("../../assets/icons");
const InvoiceItem_style_1 = require("./InvoiceItem.style");
function InvoiceItem({ val, currencyFormat, lang, type, isNew, selected, onClick, Extra, useBillItemTranslation, useOrderItemTranslation, isShowDinerFeeTooltip, showExplodedItemNetPrice, }) {
    var _a, _b, _c, _d, _e, _f;
    const theme = (0, material_1.useTheme)();
    const { invoiceItem, invoiceItemTitle, invoiceItemPrefixIcon, colorPrimary, colorSecondary, colorHighEmphasis, colorMediumEmphasis, colorLowEmphasis, colorBackground, colorGreen, styleTitleMedium, styleTitleSmall, styleBodyMedium, styleBodySmall, styleStrike, invoiceItemPrefixIconContainer, } = (0, InvoiceItem_style_1.default)({ type, selected });
    const isDinerFeeTooltip = val.key === 'com_exclusive_fixed' && isShowDinerFeeTooltip === 'show';
    const billMode = !type || type === 'bill';
    const { getTrans } = billMode ? useBillItemTranslation(lang) : useOrderItemTranslation(lang);
    const newAltDesign = (0, react_1.useMemo)(() => {
        var _a;
        if (!((_a = val.layout) === null || _a === void 0 ? void 0 : _a.format)) {
            return true;
        }
        return val.layout.format.includes('f');
    }, [(_a = val.layout) === null || _a === void 0 ? void 0 : _a.format]);
    const getIcon = () => {
        var _a;
        switch ((_a = val.layout) === null || _a === void 0 ? void 0 : _a.icon) {
            case InvoiceItemTypes_1.IconEnum.Dollar:
                return (0, jsx_runtime_1.jsx)(icons_1.Dollar, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.Yen:
                return (0, jsx_runtime_1.jsx)(icons_1.Yen, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.Rial:
                return (0, jsx_runtime_1.jsx)(icons_1.Rial, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.Percent:
                return (0, jsx_runtime_1.jsx)(icons_1.Percent, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.Bill:
                return (0, jsx_runtime_1.jsx)(icons_1.Bill, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.Discount:
                return (0, jsx_runtime_1.jsx)(icons_1.Discount, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.ItemPercent:
                return (0, jsx_runtime_1.jsx)(icons_1.ItemPercent, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.ItemBill:
                return (0, jsx_runtime_1.jsx)(icons_1.ItemBill, { color: theme.qlub.palette.dim.main });
            case InvoiceItemTypes_1.IconEnum.LoyaltyDiscount:
                return (0, jsx_runtime_1.jsx)(icons_1.LoyaltyDiscountIcon, { color: theme.qlub.palette.dim.main });
            default:
                if (type === 'topping' || type === 'order') {
                    let qty = val.qty || '0';
                    qty = Number(qty) === Math.floor(Number(qty)) ? Number(qty).toFixed(0) : Number(qty).toFixed(2);
                    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('itemQty', type === 'topping' && 'itemQtyTopping'), children: qty !== '0' ? (type === 'order' ? `${qty}x` : qty) : '' }));
                }
                if (type === 'split' || type === 'exploded-receipt-item') {
                    return (0, jsx_runtime_1.jsx)("div", { className: "splitItemQty", children: "1" });
                }
                return null;
        }
    };
    const getStyleClass = () => {
        var _a;
        switch ((_a = val.layout) === null || _a === void 0 ? void 0 : _a.style) {
            case InvoiceItemTypes_1.StyleEnum.TitleMedium:
                return styleTitleMedium;
            case InvoiceItemTypes_1.StyleEnum.TitleSmall:
                return styleTitleSmall;
            case InvoiceItemTypes_1.StyleEnum.BodyMedium:
                return styleBodyMedium;
            case InvoiceItemTypes_1.StyleEnum.BodySmall:
                return styleBodySmall;
            case InvoiceItemTypes_1.StyleEnum.BodyMediumStrike:
                return Object.assign(Object.assign({}, styleBodyMedium), styleStrike);
            case InvoiceItemTypes_1.StyleEnum.BodySmallStrike:
                return Object.assign(Object.assign({}, styleBodySmall), styleStrike);
            default:
                return styleBodyMedium;
        }
    };
    const getColorClass = () => {
        var _a;
        switch ((_a = val.layout) === null || _a === void 0 ? void 0 : _a.color) {
            case InvoiceItemTypes_1.ColorEnum.Primary:
                return colorPrimary;
            case InvoiceItemTypes_1.ColorEnum.Secondary:
                return colorSecondary;
            case InvoiceItemTypes_1.ColorEnum.HighEmphasis:
                return colorHighEmphasis;
            case InvoiceItemTypes_1.ColorEnum.MediumEmphasis:
                return colorMediumEmphasis;
            case InvoiceItemTypes_1.ColorEnum.LowEmphasis:
                return colorLowEmphasis;
            case InvoiceItemTypes_1.ColorEnum.Background:
                return colorBackground;
            case InvoiceItemTypes_1.ColorEnum.Green:
                return colorGreen;
            default:
                return type === 'topping' ? colorLowEmphasis : null;
        }
    };
    const getTitle = () => {
        var _a, _b, _c, _d, _e;
        if (billMode) {
            return getTrans(val.key, val.title, (_a = val.layout) === null || _a === void 0 ? void 0 : _a.locales, (_b = val.layout) === null || _b === void 0 ? void 0 : _b.useTitle);
        }
        return (((_c = val.titleTrans) === null || _c === void 0 ? void 0 : _c[lang]) ||
            val.title ||
            getTrans(val.key, val.title, (_d = val.layout) === null || _d === void 0 ? void 0 : _d.locales, (_e = val.layout) === null || _e === void 0 ? void 0 : _e.useTitle));
    };
    const clickHandler = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick(val);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, sx: [invoiceItem, getColorClass(), getStyleClass()], className: (0, classnames_1.default)(type === 'topping' && 'topping', isNew && 'newRow', selected && 'selectedStyle', type !== 'split' && type !== 'exploded-receipt-item' && selected && 'styleStrike', type !== 'split' && type !== 'exploded-receipt-item' && selected && 'styleStrikeLabel'), onClick: clickHandler, justifyContent: "space-between", children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, className: "billTitle", children: [type !== 'split' && type !== 'exploded-receipt-item' && ((0, jsx_runtime_1.jsx)("div", { className: "iconContainer", children: getIcon() })), (0, jsx_runtime_1.jsx)("span", { style: (0, merge_1.merge)(type === 'split' || type === 'exploded-receipt-item', invoiceItemTitle), children: getTitle() }), type === 'split' ||
                        (type === 'exploded-receipt-item' && val.isHalfItem && ((0, jsx_runtime_1.jsx)("span", { style: (0, merge_1.merge)(invoiceItemPrefixIconContainer), children: (0, jsx_runtime_1.jsx)(HalfItemIcon_1.default, { style: (0, merge_1.merge)(invoiceItemPrefixIcon) }) })))] }), (0, jsx_runtime_1.jsxs)("div", { className: "priceContainer", style: (0, merge_1.merge)(type === 'split' || type === 'exploded-receipt-item', invoiceItemTitle), children: [!((_b = val.layout) === null || _b === void 0 ? void 0 : _b.hideAltValue) && (type === 'topping' || (type === 'order' && !newAltDesign)) && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, className: (0, classnames_1.default)('itemValue', 'noWrap', {
                            altValue: !newAltDesign,
                            toppingAltValue: type === 'topping',
                        }), children: (0, jsx_runtime_1.jsx)(Format_1.default, { format: (_c = val.layout) === null || _c === void 0 ? void 0 : _c.format, value: val.altValue, currencyFormat: currencyFormat }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, className: (0, classnames_1.default)('itemValue', 'finalPrice', 'noWrap', (type === 'split' || type !== 'exploded-receipt-item') && 'split', isDinerFeeTooltip && 'dinerFeeTooltip'), children: [isDinerFeeTooltip && (0, jsx_runtime_1.jsx)(InfoOutlined_1.default, { sx: { marginRight: 1, width: '16px', height: '16px' } }), (0, jsx_runtime_1.jsx)(Format_1.default, { bold: true, format: (_d = val.layout) === null || _d === void 0 ? void 0 : _d.format, currencyFormat: currencyFormat, value: type === 'split' || type === 'exploded-receipt-item'
                                    ? showExplodedItemNetPrice
                                        ? val.thirdAltValue
                                        : val.secondAltValue
                                    : val.value })] }), Boolean(Extra) && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, className: "itemExtraStyle", children: Extra }))] }), !billMode &&
                !((_e = val.layout) === null || _e === void 0 ? void 0 : _e.hideAltValue) &&
                type !== 'split' &&
                type !== 'exploded-receipt-item' &&
                type !== 'topping' &&
                newAltDesign && ((0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, md: 12, xs: 12, className: (0, classnames_1.default)('itemValue', 'noWrap', 'altValue', {
                    newAlt: newAltDesign,
                }), sx: { pt: 1 }, children: (0, jsx_runtime_1.jsx)(Format_1.default, { format: (_f = val.layout) === null || _f === void 0 ? void 0 : _f.format, value: val.altValue, currencyFormat: currencyFormat }) }))] }));
}
